import {Inject, Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GoogleTagManagerService {
  private readonly gtmId: string;
  private initialized = false;

  constructor(
    @Inject('google_tag_manager_id') public googleTagManagerId: string,
  ) {
    this.gtmId = googleTagManagerId;
  }

  public initialize() {
    if (this.initialized) {
      throw new Error('Google Tag Manager Services had already been initialized');
    }
    this.initialized = true;
    const doc = (document as any);
    const script = doc.createElement('script');

    script.id = 'GTM-script';
    // tslint:disable-next-line:max-line-length
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f); })(window,document,'script','dataLayer','${this.gtmId}');`;

    doc.head.insertBefore(script, doc.head.firstChild);
  }

  public pushTag(dataObject) {

    if (!this.initialized) {
      throw new Error('Google Tag Manager needs to be initialized before pushing tags');
    }
    (window as any).dataLayer.push(dataObject);

  }
}
